module.exports = __webpack_public_path__ + "8cd3ae8314102092b50e602413456046.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091122_0121_w.jpg
// module id = 361
// module chunks = 0